import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getReservationsReports = catchAsync(async (locationId, params) => {
  let url = `salon/${locationId}/booking-reports`;
  const { data } = await axiosInstance.get(url, {
    params,
  });
  return data;
});
export const getSalesReports = catchAsync(async (locationId, params) => {
  let url = `salon/${locationId}/sales-reports`;
  const { data } = await axiosInstance.get(url, {
    params,
  });
  return data;
});
export const getFinanceReports = catchAsync(async (locationId, params) => {
  let url = `salon/${locationId}/finance`;
  const { data } = await axiosInstance.get(url, {
    params,
  });
  return data;
});
export const getClientsReports = catchAsync(async (params) => {
  let url = `salon/report/clients`;
  const { data } = await axiosInstance.get(url, {
    params,
  });
  return data;
});
